module.exports = __webpack_public_path__ + "img/tell_icon.97333062.jpg";